// extracted by mini-css-extract-plugin
export default {"grades":"grades_grades__Jmj++"};